class PTCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-pt-track]');
    if (!this.track) return;

    this.prevBtn = this.querySelector('[data-pt-prev]');
    this.nextBtn = this.querySelector('[data-pt-next]');
    this.thumbnails = this.querySelectorAll('[data-pt-thumbnail]');

    this.prevBtn?.addEventListener('click', () => this.move(-1));
    this.nextBtn?.addEventListener('click', () => this.move(1));

    this.thumbnails.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => this.scrollToIndex(idx));
    });

    this.dots = this.querySelectorAll('[data-pt-dot]');
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.getAttribute('data-pt-dot'));
        this.scrollToIndex(idx);
      });
    });

    // Track scroll to update active state
    this.track.addEventListener('scroll', () => this.updateActiveState(), { passive: true });

    // Set initial active state
    this.updateActiveState();
  }

  scrollToIndex(index) {
    const items = [...this.track.children];
    if (index < 0 || index >= items.length) return;
    const item = items[index];

    this.track.scrollTo({
      left: item.offsetLeft - this.track.offsetLeft,
      behavior: 'smooth'
    });
  }

  move(direction) {
    const items = [...this.track.children];
    if (items.length === 0) return;

    // Determine current index based on scroll position
    const trackRect = this.track.getBoundingClientRect();
    let minDiff = Infinity;
    let currentIndex = 0;

    items.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect();
      const diff = Math.abs((itemRect.left + itemRect.width / 2) - (trackRect.left + trackRect.width / 2));
      if (diff < minDiff) {
        minDiff = diff;
        currentIndex = index;
      }
    });

    let nextIndex = currentIndex + direction;
    // Loop around
    if (nextIndex < 0) nextIndex = items.length - 1;
    if (nextIndex >= items.length) nextIndex = 0;

    this.scrollToIndex(nextIndex);
  }

  updateActiveState() {
    const items = [...this.track.children];
    if (items.length === 0) return;

    const trackRect = this.track.getBoundingClientRect();
    let minDiff = Infinity;
    let activeIndex = 0;

    items.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect();
      const diff = Math.abs((itemRect.left + itemRect.width / 2) - (trackRect.left + trackRect.width / 2));
      if (diff < minDiff) {
        minDiff = diff;
        activeIndex = index;
      }
    });

    // Update active state on thumbnails
    this.thumbnails.forEach((thumb, idx) => {
      if (idx === activeIndex) {
        thumb.classList.add('pt-thumbnail--active');
        thumb.setAttribute('aria-current', 'true');
        // Smoothly scroll active thumbnail into view if the thumbnail row is scrollable
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        thumb.classList.remove('pt-thumbnail--active');
        thumb.removeAttribute('aria-current');
      }
    });

    // Update active state on dots
    if (this.dots) {
      this.dots.forEach((dot) => {
        const dotIdx = parseInt(dot.getAttribute('data-pt-dot'));
        if (dotIdx === activeIndex) {
          dot.classList.add('pt-dot--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('pt-dot--active');
          dot.removeAttribute('aria-current');
        }
      });
    }
  }
}

if (!customElements.get('pt-carousel')) {
  customElements.define('pt-carousel', PTCarousel);
}
